class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-scope="header"]',
			noTransition: 'no-transition',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.scrollStatePosition = 200;

		this.headerCheckScroll();
		this.triggerTransition();

		this.initEventListeners();
	}

	initEventListeners() {
		setTimeout(() => {
			$(window).on("scroll", () => this.headerCheckScroll());
		}, 500);
	}

	// Set state for scrolled
	headerCheckScroll() {
		let top = window.scrollY;
		if (top > this.scrollStatePosition) {
			this.$scope.addClass('header-scroll');
		} else {
			this.$scope.removeClass('header-scroll');
		}
	}

	triggerTransition(timeout = 400) {
		setTimeout(() => {
			this.$scope.removeClass(this.config.noTransition);
		}, timeout);
	}
}

$(document).ready(() => {
	new Header();
});
